import { AssistantPanelView } from "../Layout/types";
import useIsAssistantPageMode from "./useIsAssistantPageMode";

const useAssistantPanelAvailableViews = () => {
  const isAssistantPageMode = useIsAssistantPageMode();

  const views: AssistantPanelView[] = [];

  if (!isAssistantPageMode) {
    views.push(AssistantPanelView.LEARN);
  }

  views.push(AssistantPanelView.CHAT);

  return views;
};

export default useAssistantPanelAvailableViews;
